import { createRouter, createWebHistory } from 'vue-router';
import { routes } from '@/router/routes';
import store from '@/store/store';
import { isMobile } from '@/common/mobile';

const router = createRouter({
	hashbang: false,
	history: createWebHistory(),
	scrollBehavior() {
		return { top: 0 };
	},
	routes,
});

router.beforeEach(async (to, from, next) => {
	if (to.path.includes('merchant') || to.path.includes('management')) {
		store.commit('common/SET_IS_MERCHANT', true);
		if (!store.state.auth.merchantInfo?.seq) {
			await store.dispatch('auth/getMerchantInfo', to.params.merchant_seq);
		}
	} else {
		store.commit('common/SET_IS_MERCHANT', false);
	}
	if (to.fullPath.includes('/service/cs')) {
		if (isMobile()) {
			if (to.fullPath === '/service/cs/cs') {
				next({ name: 'notice' });
				return;
			}
		} else {
			if (
				to.fullPath === '/service/cs/notice' ||
				to.fullPath === '/service/cs/faq' ||
				to.fullPath === '/service/cs/inquiry' ||
				to.fullPath === '/service/cs/inquiry_detail'
			) {
				next({ name: 'cs' });
				return;
			}
		}
	}

	if (to.matched.some(record => record.meta.auth)) {
		try {
			await store.dispatch('auth/refreshToken');
		} catch (e) {
			next({ name: 'auth-login' });
			return;
		}

		if (!store.getters['auth/is_logged_in']) {
			next({ name: 'auth-login' });
		} else {
			next();
		}
	} else {
		next();
	}
});
export default router;
